import { render, staticRenderFns } from "./KeyMeasureInfoCard.vue?vue&type=template&id=dd8f2608&scoped=true&"
import script from "./KeyMeasureInfoCard.vue?vue&type=script&lang=js&"
export * from "./KeyMeasureInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./KeyMeasureInfoCard.vue?vue&type=style&index=0&id=dd8f2608&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd8f2608",
  null
  
)

export default component.exports